import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IccOrphanExemptionDrugImportsService } from 'app/core/services/icc/icc-orphan-exemption-drug-imports.service';
import { ImportUploadResult, IccImportUploadComponent } from '../../components/icc-import-upload/icc-import-upload.component';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';


@Component({
    selector: 'app-icc-import-orphan-exemption-drugs',
    templateUrl: './icc-import-orphan-exemption-drugs.component.html',
    styleUrls: ['./icc-import-orphan-exemption-drugs.component.scss'],
    imports: [ImportNavComponent, IccImportUploadComponent]
})
export class IccImportOrphanExemptionDrugsComponent {
  private orphanExemptionDrugImportsService = inject(IccOrphanExemptionDrugImportsService);
  private router = inject(Router);

  errors: string[] = [];

  onUploadComplete({ clientId, name, upload }: ImportUploadResult) {
    this.orphanExemptionDrugImportsService.create(clientId, name, upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/icc-claims/imports/orphan-exemption-drugs/history']);
      },
      (error: HttpErrorResponse) => {
        this.errors = error.error.errors;
      }
    );
  }

  onUploadStart() {
    this.errors = [];
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
